import { Divider, Typography } from 'antd'
import React from 'react'
import GetBin from '../../../components/Wash/ViewBin/GetBin'

const ViewBinPage = ({userData}) => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography.Title
          level={5}
          style={{
            margin: 0,
          }}
        >
          View Bin
        </Typography.Title>
      </div>
      <Divider style={{ marginTop: 8 }} />
      <GetBin userData={userData}/>

    </>
  )
}

export default ViewBinPage